import type { ReactNode } from "react";

export function PageHeader({
  title, subtitle, actions,
}: {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
}) {
  return (
    <div className="flex flex-col gap-2 border-b border-border-subtle px-3 py-3 sm:flex-row sm:items-center sm:justify-between sm:px-6 sm:py-4">
      <div>
        <h1 className="text-base font-bold tracking-tight text-text sm:text-lg">{title}</h1>
        {subtitle && <p className="mt-0.5 text-[12.5px] text-text-sec">{subtitle}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
}

export function PageBody({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={`px-3 py-4 sm:px-6 sm:py-6 ${className || ""}`}>{children}</div>;
}
